"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRefinanceState = void 0;
var MortgageCommonState_init_1 = require("@/pages/mortagage/states/MortgageCommonState.init");
exports.defaultRefinanceState = __assign(__assign({}, MortgageCommonState_init_1.defaultMortgageCommonState), { outstandingMortgage: 4000000, outstandingMortgageMin: 0, outstandingMortgageMax: 50000000, outstandingMortgageStep: 500000, currentTenor: 10, currentTenorMin: 0, currentTenorMax: 30, currentTenorStep: 1, existingInterestRate: 2.5, existingInterestRateMin: 0, existingInterestRateMax: 10, existingInterestRateStep: 0.01, newPropertyValue: 9000000, newPropertyValueMin: 0, newPropertyValueMax: 100000000, newPropertyValueStep: 500000, newLoan: 4050000, newLoanMin: 0, newLoanMax: 100000000, newLoanPercent: 45, newLoanStep: 500000, newTenor: 10, newTenorMin: 0, newTenorMax: 30, newTenorStep: 1, newInterestRate: 3.5, newInterestRateMin: 0, newInterestRateMax: 10, newInterestRateStep: 0.01, result: null });
